import { apiClient } from '@api/apiClient';
import { V4ApiResponse } from '@api/types';
import { ToastType } from '@components/Toast';
import { DormantAccountApiResponse } from '@store/customers/dormantAccount';
import { createError } from '@utils/errorUtils';
import { handleToast } from '@utils/utils';

export const fetchDormantAccountsData = async (payload: unknown) => {
  try {
    const response: V4ApiResponse<DormantAccountApiResponse> =
      await apiClient.post('Customer/dormantaccounts', payload);
    return response;
  } catch (error: unknown) {
    const e = createError(error, 'Failed to fetch dormant accounts Data');
    handleToast(ToastType.Error, e.message);
  }
};

export const exportDormantAccountsData = async (
  payload: unknown,
): Promise<void> => {
  try {
    const response: string = await apiClient.post(
      'Customer/exportdormantaccounts',
      payload,
    );

    if (response) {
      const blob = new Blob([response], { type: 'text/csv;charset=utf-8;' });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'DormantAccounts.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error: unknown) {
    const e = createError(error, 'Failed to export dormant accounts Data');
    handleToast(ToastType.Error, e.message);
  }
};
